/**
 * Stimulus controller that puts a submit button into a loading state when its
 * form is submitted, matching the legacy jQuery `button-loading` + `disabled`
 * pattern used on the registration/login pages.
 * @example
 * // <form data-controller="loading-submit" data-action="submit->loading-submit#submit">
 * //   <button type="submit" data-loading-submit-target="button">Submit</button>
 * // </form>
 */
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button'];

  submit(event) {
    const button = this.hasButtonTarget ? this.buttonTarget : event.submitter;

    if (!button) {
      return;
    }
    button.classList.add('button-loading');
    button.disabled = true;
  }
}
